import React from 'react'
import { Button, Message } from 'semantic-ui-react'

/**
 * Catches a rendering failure inside one CRM view so the rest of the app (menu, other tabs) keeps working.
 * Reset it by changing its `resetKey` (the shell passes the current view) or with the retry button.
 */
export class CrmErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { failed: false }
    }

    static getDerivedStateFromError() {
        return { failed: true }
    }

    componentDidUpdate(previous) {
        if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false })
    }

    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error('[CRM] view crashed:', error)
    }

    render() {
        if (this.state.failed) {
            return (
                <Message negative role="alert">
                    <Message.Header>Something went wrong showing this view</Message.Header>
                    <p>Your data is safe. Try again, or switch to another tab.</p>
                    <Button type="button" size="small" onClick={() => this.setState({ failed: false })}>
                        Try again
                    </Button>
                </Message>
            )
        }
        return this.props.children
    }
}
